import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6v15","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M9 3l3 3l3 -3","key":"svg-2"}]]

/**
 * IconArrowDownTail
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi10YWlsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiA2djE1IiAvPgogIDxwYXRoIGQ9Ik05IDE4bDMgM2wzIC0zIiAvPgogIDxwYXRoIGQ9Ik05IDNsMyAzbDMgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-down-tail
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownTail = createReactComponent('outline', 'arrow-down-tail', 'ArrowDownTail', __iconNode);

export default IconArrowDownTail;